import { isResponseStatus } from '@gov-nx/api';
import type { GovError } from '@gov-nx/core/app';
import { usePersonStore } from '@gov-nx/store';
import { useRosBusinessPersonQuery } from './useRosBusinessPersonQuery';

interface BusinessPersonLoaderProps {
	onError?: (error: GovError) => void;
}

export const useBusinessPersonLoader = (props?: BusinessPersonLoaderProps) => {
	const businessPerson = usePersonStore('business');
	const setBusinessPersonData = usePersonStore('setBusinessPersonData');

	const query = useRosBusinessPersonQuery({
		onSuccess: (data) => setBusinessPersonData(data),
		onError: props?.onError,
		refetchOnWindowFocus: false,
		retry: 0,
		enabled: !businessPerson,
		config: { errorIgnoreFilter: isResponseStatus(500) },
	});
	return { businessPerson, error: query.error };
};
